import { WorkEmailHistoryAllDialogStore } from './work-email-history-all-dialog.store';
import { fb } from '../../../../modules/shared/shared.global-service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { dateTimeField } from '../../../../modules/shared/components/kit/table/table.fields';
import { emailHistoryFrag } from './work-email-history-all-dialog.query';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { EmailHistoryObject } from '@libs/types/src/services/object-type/email-history.object';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { RenderHtmlDialogComponent } from '../../../kit/dialog/render-html-dialog/render-html-dialog.component';
import { EmailHistoryGqlService } from '../../../../services/email-history.gql-service';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-work-email-history-all-dialog',
    templateUrl: './work-email-history-all-dialog.component.html',
    styleUrl: './work-email-history-all-dialog.component.scss',
    providers: [WorkEmailHistoryAllDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TableComponent,
    ],
})
export class WorkEmailHistoryAllDialogComponent extends BaseDialogComponent {

    public readonly store = inject(WorkEmailHistoryAllDialogStore);
    public readonly dialogService = inject(BaseDialogService);
    public readonly emailHistoryGql = inject(EmailHistoryGqlService);

    protected form = fb.group({});

    protected columns: TableColumn[] = [
        dateTimeField('createdAt'),
        { name: 'recipientAddress' },
    ];

    protected readonly emailHistoryFrag = emailHistoryFrag;

    protected readonly additionalFilter = [
        [{
            column: 'type',
            operator: 'EQ',
            value: [this.dialogConfig.data.type],
        }],
        [{
            column: 'typeId',
            operator: 'EQ',
            value: [this.dialogConfig.data.typeId],
        }],
    ];

    protected async open(item: EmailHistoryObject): Promise<void> {
        const res = await this.emailHistoryGql.getServiceEmailHistory(
            FilterBuilder.filterById(item.id),
            'content',
        );
        const content = res?.items?.[0]?.content || '';

        this.dialogService.open(
            RenderHtmlDialogComponent,
            {
                data: {
                    content,
                },
                baseZIndex: 9999,
            },
        );
    }

}
